import React from 'react';
interface Option {
  id: string;
  label: string;
}
export function ChipGroup({
  label,
  options,
  selected,
  onSelect,
  multiple = false
}: {
  label: string;
  options: Option[];
  selected: string[];
  onSelect: (id: string) => void;
  multiple?: boolean;
}) {
  return <fieldset data-id="element-396" data-mp="21o1lgs3bt5ll">
      <legend className="mb-2.5 text-[12px] font-semibold uppercase tracking-wide text-mist" data-id="element-397" data-mp="21njsc4byn7hw">
        {label}
      </legend>
      <div className="flex flex-wrap gap-2" role="group" aria-label={label} data-id="element-398" data-mp="1my42cqk97639">
        {options.map(o => {
        const active = selected.includes(o.id);
        return <button key={o.id || 'todos'} type="button" aria-pressed={active} onClick={() => onSelect(o.id)} className={`rounded-xl border px-3.5 py-2 text-[13px] font-semibold transition-[background-color,border-color,color] duration-150 ease-smooth ${active ? 'border-neon bg-neon/15 text-white shadow-[0_0_0_1px_rgba(31,123,255,0.35),0_8px_24px_-14px_rgba(31,123,255,0.9)]' : 'border-line bg-surface2/60 text-mist hover:border-neon/50 hover:text-white'}`} data-id="element-399" data-mp="1dza0ako5lnib">
              {o.label}
            </button>;
      })}
      </div>
      {multiple ? <p className="mt-2 text-[12px] text-mist/80" data-id="element-400" data-mp="30qqrusmd4vim">Podés elegir más de una opción.</p> : null}
    </fieldset>;
}